import React, { useState } from "react";
import { Box, Typography, Breadcrumbs, Link } from "@mui/material";
import PendingSubmission from "./PendingSubmission";
import ApprovedSubmission from "./ApprovedSubmission";

function AdminFileManager({ selectedStatus }) {
  return (
    <Box
      sx={{ p: 2, height: "100vh", overflowY: "auto", padding: 0, margin: 0 }}
    >
      {selectedStatus === "pending" ? (
        <PendingSubmission />
      ) : (
        <ApprovedSubmission />
      )}
    </Box>
  );
}

export default AdminFileManager;
